module.exports = __webpack_public_path__ + "img/Weapon_64.642fc8bd.png";